import { lgStyle, mdStyle, smStyle } from '@/components/Adapter'
import styled from 'styled-components'
import { CoinTitleStyled } from '../../style'

export const CoinAboutStyled = styled.section`
  display: flex;
  flex-direction: column;
`

export const CoinAboutTitleStyled = styled(CoinTitleStyled)`
  font-weight: 500;
  font-size: 16px;
  ${smStyle} {
    font-weight: 700;
    font-size: 24px;
  }
`

export const CoinAboutCTStyled = styled.div`
  display: flex;
  gap: 16px 40px;
  flex-wrap: wrap;
  & > div {
    width: 100%;
  }
  ${smStyle} {
    & > div {
      width: 100%;
    }
  }

  ${mdStyle} {
    & > div {
      max-width: fit-content;
    }
    flex-wrap: wrap;
    justify-content: space-between;
    &[data-isequally='true'] {
      & > div {
        min-width: calc(50% - 20px);
      }
    }
  }

  ${lgStyle} {
    & > div {
      max-width: max-content;
    }
    flex-wrap: nowrap;
  }

  &[data-top='true'] {
    margin-top: 24px;
  }
`

export const CoinAboutCBWStyled = styled('div')`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  ${smStyle} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  ${mdStyle} {
    grid-template-columns: 1fr 1fr;
  }

  ${lgStyle} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  &[data-top='true'] {
    margin-top: 24px;
  }
`

export const CoinAboutDocsStyled = styled.div`
  &[data-isexpand='false'] {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;
    overflow: hidden;
    text-overflow: ellipsis;

    ${smStyle} {
      -webkit-line-clamp: 5;
    }

    ${mdStyle} {
      -webkit-line-clamp: 6;
    }

    ${lgStyle} {
      -webkit-line-clamp: 4;
    }
  }
`
